import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewEncapsulation
} from "@angular/core";
import { Meta } from "@angular/platform-browser";
import { CmsData } from "@dotcom-frontend/data";
import { LgIconComponent } from "@legal-and-general/canopy";
import { ImageService } from "../../../services/image/image.service";
import { DynamicComponent } from "../../utils/dynamic-loader/dynamic.component";

@Component({
  selector: "dotcom-frontend-share",
  templateUrl: "./Share.component.html",
  styleUrl: "./Share.component.scss",
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [LgIconComponent]
})
export class ShareComponent implements DynamicComponent, OnInit, OnDestroy {
  @Input() data: CmsData | undefined;

  shareUrl: string | undefined;
  title: string | undefined;
  image: string | undefined;
  imageAlt: string | undefined;

  constructor(
    private imageService: ImageService,
    private meta: Meta
  ) {}

  ngOnInit() {
    this.setData();
    this.setMetaTags();
  }

  setData() {
    if (this.data) {
      this.shareUrl = this.data["url"];
      this.title = this.data["title"];
      this.imageAlt = this.data["image"] && this.data["image"]["altText"];
      this.image = this.imageService.getImageUrl(this.data["image"], 1000);
    }
  }

  setMetaTags() {
    this.manageMetaTag("og:title", this.title, true);
    this.manageMetaTag("og:type", "website", true);
    this.manageMetaTag("og:image", this.image, true);
    this.manageMetaTag("og:image:alt", this.imageAlt, true);
    this.manageMetaTag("og:url", this.shareUrl, true);
    this.manageMetaTag("twitter-x:card", "summary_large_image");
    this.manageMetaTag("twitter-x:title", this.title);
    this.manageMetaTag("twitter-x:image", this.image);
    this.manageMetaTag("twitter-x:image:alt", this.imageAlt);
  }

  manageMetaTag(name: string, content?: string, isOg = false) {
    if (content) {
      if (isOg) {
        this.meta.updateTag({ property: name, content });
      } else {
        this.meta.updateTag({ name, content });
      }
    } else {
      if (isOg) {
        this.meta.removeTag(`property="${name}"`);
      } else {
        this.meta.removeTag(`name="${name}"`);
      }
    }
  }

  sharePage(platform: string) {
    if (this.data) {
      const shareUrl = encodeURIComponent(this.data["url"].toString());
      switch (platform) {
        case "linkedin":
          this.shareLinkedin(shareUrl);
          break;
        case "twitter-x":
          this.shareTwitterX(shareUrl);
          break;
        case "email":
          this.shareEmail(shareUrl);
          break;

        default:
          break;
      }
    }
  }

  shareLinkedin(shareUrl: string) {
    window.open(
      `https://www.linkedin.com/shareArticle?mini=true&url=${shareUrl}`
    );
  }

  shareTwitterX(shareUrl: string) {
    window.open(
      `https://twitter.com/intent/tweet?url=${shareUrl}&text=${this.title}`
    );
  }

  shareEmail(shareUrl: string) {
    window.open(
      `mailto:?subject=${this.title}&body=I saw this article and thought you might be interested ${shareUrl}`
    );
  }

  ngOnDestroy() {
    this.manageMetaTag("og:title", undefined, true);
    this.manageMetaTag("og:type", undefined, true);
    this.manageMetaTag("og:image", undefined, true);
    this.manageMetaTag("og:image:alt", undefined, true);
    this.manageMetaTag("og:url", undefined, true);
    this.manageMetaTag("twitter-x:card", undefined);
    this.manageMetaTag("twitter-x:title", undefined);
    this.manageMetaTag("twitter-x:image", undefined);
    this.manageMetaTag("twitter-x:image:alt", undefined);
  }
}
